// In JS 0.2 + 13.6 = 13.799999999999999, this fix it
export const roundDecimal = (value: number, decimals = 1): number => {
    const factor = Math.pow(10, decimals);
    const rounded = Math.round((value + Number.EPSILON) * factor) / factor;
    return parseFloat(rounded.toFixed(decimals));
};

export const getNbDecimal = (value: number): number => {
    return (value.toString().split(".")[1] || "").length;
};
